<div
  [qimaShadowLevel]="shadowService.shadowLevel.TWO"
  class="account-menu"
  qimaShadow
>
  <div class="account-menu__user-info">
    <div class="account-menu__user-info__icon">
      <qima-icon [qimaIconName]="qimaIcon.iconName.USER"></qima-icon>
    </div>

    <div class="qima-ml-s">
      <div class="account-menu__user-info__name">{{ currentUser.firstName }} {{ currentUser.lastName }}</div>
      <div class="account-menu__user-info__name-label">{{ currentUser.login }}</div>
    </div>
  </div>
  <div
    (click)="logout()"
    (keydown.enter)="logout()"
    class="account-menu__logout"
  >
    <qima-icon
      [qimaIconName]="qimaIcon.iconName.LOGOUT"
      class="account-menu__logout__avatar"
    ></qima-icon>
    <span class="account-menu__logout__label">{{ 'APP_HEADER.ACCOUNT.LOGOUT' | translate }}</span>
  </div>
</div>
